import { ComponentRenderer, Page } from "@ludens-reklame/rubics-v3-react/page";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store/types";
import { CourseProvider } from "./context/course-context.js";

export const App: React.FC<{ store: Store; renderer: ComponentRenderer }> = ({
  store,
  renderer,
}) => {
  return (
    <Page store={store} useCartContext renderComponent={renderer}>
      {({ header, main, footer }) => {
        return (
          <CourseProvider>
            {header}
            <main>{main}</main>
            {footer}
          </CourseProvider>
        );
      }}
    </Page>
  );
};
